import { render } from "./PrezzoAcquisto.vue?vue&type=template&id=e25888ba"
import script from "./PrezzoAcquisto.vue?vue&type=script&lang=js"
export * from "./PrezzoAcquisto.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__